<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
    export default {
        name: 'app'
    }
</script>

<style>
    html, body, #app, div, img, button, span, i, p{
    	margin: 0;
    	padding: 0;
    }
    img{
    	font-size: 0;
    }
    html{
    	font-size: 62.5%;
		font-weight: lighter;
		font-family: 'D-DIN', sans-serif;
    	-webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    }
    @media screen and (max-aspect-ratio: 1/1) { /*竖屏*/ }
    @media screen and (min-aspect-ratio: 1/1) { /*横屏*/ }
	@media screen and (min-width: 1200px){ /*大屏显示器*/ }
	@media screen and (min-width: 970px) and (max-width: 1200px){  /*电脑*/ }
	@media screen and (min-width: 768px) and (max-width: 970px){ /*平板*/ }
	@media screen and (max-width: 768px){ /*手机*/ }
	
	.iframe-body{
		width: 100%;
		height: 100%;
		overflow-x: hidden!important;
		overflow-y: scroll!important;
		scrollbar-width: none;
		scrollbar-color: transparent transparent;
	}
	.iframe-body::-webkit-scrollbar{
		width: 0px;
	}
	.iframe-body::-webkit-scrollbar-thumb{
		border-radius: 0px;
		background-color: transparent;
	}
	.iframe-body::-webkit-scrollbar-button{
		display: none;
	}
	.iframe-body::-webkit-scrollbar-track{
		background-color: transparent;
	}
</style>
